<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="sec-26"><section class="chapter" epub:type="chapter" id="section_level_h1_01" role="doc-chapter" title="Righteousness"><h1 class="chapter2" id="pz26-1"><a href="#/contents#ba_06" id="ab_06"><b>Righteousness</b></a></h1>
<p id="pz26-3">For He made Him who knew no sin to be sin for us, that we might become the righteousness of God in Him.</p>
<p class="right" id="pz26-4"><em>II Corinthians 5:21</em></p>
<p id="pz26-5">But of Him you are in Christ Jesus, who became for us wisdom from God—and righteousness and sanctification and redemption.</p>
<p class="right" id="A_Wr"><em>I Corinthians 1:30</em></p>
<p id="pz26-6">And be found in Him, not having my own righteousness, which is from the law, but that which is through faith in Christ, the righteousness which is from God by faith.</p>
<p class="right" id="pz26-7"><em>Philippians 3:9</em></p>
<p id="pz26-8">Just as Abraham “believed God, and it was accounted to him for righteousness.”</p>
<p id="pz26-9">Therefore know that only those who are of faith are sons of Abraham.</p>
<p class="right" id="pz26-10"><em>Galatians 3:6, 7</em></p>
<p id="pz26-11">Even the righteousness of God, through faith in Jesus Christ, to all and on all who believe. For there is no difference.</p>
<p class="right" id="pz26-12"><em>Romans 3:22</em></p>
<p id="pz27-1">Being justified freely by His grace through the redemption that is in Christ Jesus,</p>
<p id="pz27-2">whom God set forth as a propitiation by His blood, through faith, to demonstrate His righteousness, because in His forbearance God had passed over the sins that were previously committed,</p>
<p id="pz27-3">to demonstrate at the present time His righteousness, that He might be just and the justifier of the one who has faith in Jesus.</p>
<p class="right" id="pz27-4"><em>Romans 3:24–26</em></p>
<p id="pz27-5">But to him who does not work but believes on Him who justifies the ungodly, his faith is accounted for righteousness.</p>
<p class="right" id="pz27-6"><em>Romans 4:5</em></p>
<p id="pz27-7">In righteousness you shall be established;</p>
<p id="pz27-8">You shall be far from oppression, for you shall not fear;</p>
<p id="pz27-9">And from terror, for it shall not come near you.</p>
<p id="pz27-10">Indeed they shall surely assemble, but not because of Me.</p>
<p id="pz27-11">Whoever assembles against you shall fall for your sake.</p>
<p id="pz27-12">“Behold, I have created the blacksmith</p>
<p id="AOU">Who blows the coals in the fire,</p>
<p id="AsC">Who brings forth an instrument for his work;</p>
<p id="Abv">And I have created the spoiler to destroy.</p>
<p id="A5S">No weapon formed against you shall prosper,</p>
<p id="Aex">And every tongue which rises against you in judgment</p>
<p id="pz28-2">You shall condemn.</p>
<p id="pz28-3">This is the heritage of the servants of the L<span class="smallcaps">ORD</span>,</p>
<p id="A6e">And their righteousness is from Me,”</p>
<p id="pz28-4">Says the L<span class="smallcaps">ORD</span>.</p>
<p class="right" id="pz28-5"><em>Isaiah 54:14–17</em></p>
<p id="pz28-6">For what the law could not do in that it was weak through the flesh, God did by sending His own Son in the likeness of sinful flesh, on account of sin: He condemned sin in the flesh,</p>
<p id="pz28-7">that the righteous requirement of the law might be fulfilled in us who do not walk according to the flesh but according to the Spirit.</p>
<p class="right" id="Ahn"><em>Romans 8:3, 4</em></p>
<p id="pz28-8">For if by the one man’s offense death reigned through the one, much more those who receive abundance of grace and of the gift of righteousness will reign in life through the One, Jesus Christ.</p>
<p class="right" id="APn"><em>Romans 5:17</em></p>
<p id="pz28-9">What shall we say then? That Gentiles, who did not pursue righteousness, have attained to righteousness, even the righteousness of faith.</p>
<p class="right" id="ARsX"><em>Romans 9:30</em></p>
<p id="pz29-1">For whom He foreknew, He also predestined to be conformed to the image of His Son, that He might be the firstborn among many brethren.</p>
<p id="pz29-2">Moreover whom He predestined, these He also called; whom He called, these He also justified; and whom He justified, these He also glorified.</p>
<p class="right" id="A2-"><em>Romans 8:29, 30</em></p>
<p id="pz29-3">And if Christ is in you, the body is dead because of sin, but the Spirit is life because of righteousness.</p>
<p class="right" id="AW5"><em>Romans 8:10</em></p>
<p id="pz29-4">The work of righteousness will be peace,</p>
<p id="AfQ">And the effect of righteousness, quietness and assurance forever.</p>
<p class="right" id="pz29-6"><em>Isaiah 32:17</em></p>
<p id="pz29-7">For with the heart one believes unto righteousness, and with the mouth confession is made unto salvation.</p>
<p class="right" id="pz29-8"><em>Romans 10:10</em></p>
<p id="pz29-9">Not by works of righteousness which we have done, but according to His mercy He saved us, through the washing of regeneration and renewing of the Holy Spirit.</p>
<p class="right" id="pz29-10"><em>Titus 3:5</em></p>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter06.vue?7b50cdba